import apiReporting from '@/api/reporting'

const state = {
  error: null,
  isSubmitting: false,
  isLoading: false,
  data: null,
}

export const mutationTypes = {
  updateReportingStart: '[update reporting] Update reporting start',
  updateReportingSuccess: '[update reporting] Update reporting success',
  updateReportingFailure: '[update reporting] Update reporting failure',

  getReportingStart: '[update reporting] Get reporting start',
  getReportingSuccess: '[update reporting] Get reporting success',
  getReportingFailure: '[update reporting] Get reporting failure',
}

export const actionTypes = {
  updateReporting: '[update reporting] Update reporting',
  getReporting: '[update reporting] Get reporting',
}

const mutations = {
  [mutationTypes.updateReportingStart](state) {
    state.isSubmitting = true
  },

  [mutationTypes.updateReportingSuccess](state) {
    state.isSubmitting = false
  },

  [mutationTypes.updateReportingFailure](state, payload) {
    state.error = payload
    state.isSubmitting = false
  },

  [mutationTypes.getReportingStart](state) {
    state.data = null
    state.isLoading = true
  },

  [mutationTypes.getReportingSuccess](state, payload) {
    state.data = payload
    state.isLoading = false
  },

  [mutationTypes.getReportingFailure](state) {
    state.isLoading = false
  },
}

const actions = {
  [actionTypes.updateReporting](context, {id, reportingInput}) {
    context.commit(mutationTypes.updateReportingStart)
    return new Promise((resolve) => {
      apiReporting
        .updateReporting(id, reportingInput)
        .then((response) => {
          context.commit(mutationTypes.updateReportingSuccess)
          resolve(response.data)
        })
        .catch((resolve) => {
          context.commit(
            mutationTypes.updateReportingFailure,
            resolve.response.data.errors
          )
        })
    })
  },

  [actionTypes.getReporting](context, {id}) {
    context.commit(mutationTypes.getReportingStart)
    return new Promise((resolve) => {
      apiReporting
        .getReporting(id)
        .then((response) => {
          context.commit(mutationTypes.getReportingSuccess, response.data)
          resolve(response.data)
        })
        .catch(() => {
          context.commit(mutationTypes.getReportingFailure)
        })
    })
  },
}

export default {
  state,
  mutations,
  actions,
}
